export const commentData = {
	data() {
		return {
			headerList: [
				{
					prop: 'date',
					label: '时间',
					width: 200,
					tooltip: true
				},
				{
					prop: 'show_title',
					label: '视频标题',
					width: 250
				},
				{
					prop: 'flow',
					label: '流量消耗(GB)',
					width: 150,
					tooltip: true
				},
				{
					prop: 'product_title',
					label: '来源课程',
					width: 200
				},
				{
					prop: 'order_no',
					label: '来源订单',
					width: 300
				},
			],
			RechargeLog:[//购买记录
				{
					prop: 'created_time',
					label: '变更时间',
					width: 200,
					tooltip: true
				},
				{
					prop: "action_desc",
					label: '变更类型',
					width: 250
				},
				{
					prop: "flow",
					label: '充值/扣除流量(GB)',
					width: 150,
					tooltip: true
				},
				{
					prop: 'plan_title',
					label: '流量包',
					width: 200
				},
				{
					prop: "remark",
					label: '相关',
					width: 300
				},
			],
		}
	}
}